import type { NotificationItem } from './types';
import { APPROVAL_ROUTES } from '../approval/navigation';

/**
 * Resolves the in-app route a notification should navigate to when clicked.
 *
 * Navigation is intentionally deferred: the approval landing pages do not exist
 * yet, so this returns null for now (clicking only marks the notification read).
 * When the target pages land, wire them up here — a candidate mapping:
 *
 *   approval.employee.pending →
 *     `/app/nastaveni/sprava-firmy/sprava-uzivatelu/${data.employeeId}`
 *     (renders features/manage/users/Users.tsx, already exists)
 *
 *   approval.user.pending    → super-admin pending-users queue    (page TODO)
 *   approval.company.pending → super-admin pending-companies queue (page TODO)
 */
const APPROVAL_REQUEST_TYPES = [
  'approval.request.approved',
  'approval.request.rejected',
  'approval.request.commented',
];

export const resolveNotificationRoute = (notification: NotificationItem): string | null => {
  if (notification.type === 'pdf.generation.done' && notification.data.pdfId) {
    return `/app/pdf-tisk?id=${notification.data.pdfId}`;
  }
  if (APPROVAL_REQUEST_TYPES.includes(notification.type) && notification.data.requestId) {
    return `${APPROVAL_ROUTES.mine}?id=${encodeURIComponent(String(notification.data.requestId))}`;
  }
  return null;
};
